import { useContext, useEffect } from "react";
import InputField from "./InputField";
import SelectField from "./SelectField";
import { FormContext } from "./FormField";
import inputStyle from "./InputStyles.module.css";
import styles from "./Webhook.module.css";

const WebhookForList: { label: string; value: any }[] = [
  { label: "Generic", value: "GENERIC" },
  { label: "OTRS Ticket", value: "OTRS_TICKET" },
];
const WebhookFormatList: { label: string; value: any }[] = [
  { label: "JSON Data", value: "json" },
  { label: "Form Data", value: "form" },
];

function WebhookAction({ type }: { type: "new" | "edit" }) {
  const { fields, setValue } = useContext(FormContext);
  useEffect(() => {
    if (type == "new") {
      setValue({ format: WebhookFormatList[0].value })
    }
  }, []);
  return (
    <div className={styles.card}>
      <div></div>
      <div>
        <InputField
          name="name"
          label="Webhook Nombre"
          initialValue={fields.name}
          inputClassName={inputStyle.input}
          labelClassName={inputStyle.label}

          onChange={(e) => {
            setValue({ name: e.target.value });
          }}
        />
      </div>

      <div>
        <InputField
          name="url"
          label="URL de destino"
          onChange={(e) => {
            setValue({ url: e.target.value });
          }}
          initialValue={fields.url}
          inputClassName={inputStyle.input}
          labelClassName={inputStyle.label}
        />
      </div>

      <div>
        <SelectField
          name="for"
          label="Webhook Para"
          onChange={(e) => {
            setValue({ webhook_for: e.target.value });
          }}
          initialValue={fields.webhook_for}
          options={WebhookForList}
          inputClassName={inputStyle.input}
          labelClassName={inputStyle.label}
        />
      </div>

      {fields.webhook_for == "GENERIC" && (
        <div>
          <SelectField
            name="format"
            label="Webhook Tipo/formato"
            onChange={(e) => {
              console.log(e.target.value, " selected value")
              setValue({ format: e.target.value });
            }}
            initialValue={type == "new" ? WebhookFormatList[0].value : fields.format}
            options={WebhookFormatList}
            inputClassName={inputStyle.input}
            labelClassName={inputStyle.label}
          />
        </div>
      )}
    </div>
  );
}

export default WebhookAction;
